import { render, staticRenderFns } from "./S2Textarea.vue?vue&type=template&id=20bacf32&scoped=true"
import script from "./S2Textarea.vue?vue&type=script&lang=js"
export * from "./S2Textarea.vue?vue&type=script&lang=js"
import style0 from "./S2Textarea.vue?vue&type=style&index=0&id=20bacf32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bacf32",
  null
  
)

export default component.exports